module.exports = __webpack_public_path__ + "static/media/img-submit.b086ca36.svg";